<div class="card text-left">
  <div class="card-body" style="background-color: #e4ecf2">
    <h4 class="card-title" style="text-align: center">Phone Verification</h4>
  </div>

  <div class="form-row" style="margin: 12px">
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-control
          [nzSpan]="25"
          nzHasFeedback
          [nzErrorTip]="contactNumberErrorTpl"
        >
          <nz-input-group>
            <input
              formControlName="contactNumber"
              id="contactNumber"
              placeholder="Mobile. Ex: 018XXXXXXXX"
              nz-input
              type="text"
            />
          </nz-input-group>
          <ng-template #contactNumberErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please input your contact number!
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Max Length Reached
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              Contact Number Must be 11 digit
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')">
              <div>Only Digits are allowed</div>
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>

    <button
      nz-button
      [nzType]="'primary'"
      nzShape="round"
      [disabled]="!validateForm.valid"
      (click)="submitForm()"
    >
      <span>Submit</span>
    </button>

    <div>
      <nz-modal
        [(nzVisible)]="isVisible"
        nzTitle="OTP Submit (prompt will close in 2 mintues)"
        (nzOnCancel)="handleCancel()"
      >
        <ng-container *nzModalContent>
          <form nz-form [formGroup]="otpForm" (ngSubmit)="submitOtp()">
            <nz-form-item>
              <nz-form-label [nzSpan]="6">OTP</nz-form-label>
              <nz-form-control
                [nzSpan]="14"
                [nzErrorTip]="contactNumberErrorTpl"
              >
                <input
                  nz-input
                  formControlName="otp"
                  type="text"
                  placeholder="Enter 5 digit otp"
                />
              </nz-form-control>
              <ng-template #contactNumberErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input your OTP!
                </ng-container>
                <ng-container *ngIf="control.hasError('pattern')">
                  OTP Number Must be 5 digits
                </ng-container>
              </ng-template>
              <div>
                <button
                  nz-button
                  nzType="primary"
                  nzShape="round"
                  [disabled]="!otpForm.valid"
                >
                  Submit
                </button>
              </div>
            </nz-form-item>
          </form>
        </ng-container>
        <div *nzModalFooter style="display: none"></div>
      </nz-modal>
    </div>

    <!-- <form nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
            <nz-form-item nz-row class="register-area">
              <nz-form-control [nzSpan]="14" [nzOffset]="6">
                <button nz-button nzType="primary">Submit</button>
              </nz-form-control>
            </nz-form-item>
          </form> -->
  </div>
</div>
